module.exports = __webpack_public_path__ + "static/img/d10-1.8fc95ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/english/home/mobile/role/d10-1.png
// module id = Vigy
// module chunks = 0